import { apiClient } from "@/shared/api/client";
import type { UpdateWorkerProfilePayload, WorkerProfile } from "@/features/workers/types";

export async function fetchMyProfile(): Promise<WorkerProfile> {
  const { data } = await apiClient.get<WorkerProfile>("/workers/me");
  return data;
}

export async function updateMyProfile(payload: UpdateWorkerProfilePayload): Promise<WorkerProfile> {
  const { data } = await apiClient.put<WorkerProfile>("/workers/me", payload);
  return data;
}

export async function completeOnboarding(): Promise<WorkerProfile> {
  const { data } = await apiClient.post<WorkerProfile>("/workers/me/complete-onboarding");
  return data;
}

export async function uploadPhoto(file: File): Promise<WorkerProfile> {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post<WorkerProfile>("/workers/me/photo", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function uploadEligibilityDoc(file: File): Promise<WorkerProfile> {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post<WorkerProfile>(
    "/workers/me/eligibility-document",
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}

export interface UploadCertPayload {
  file: File;
  /** One of the four allow-listed cert categories. Required. */
  category: string;
  name?: string;
  expires_on?: string; // YYYY-MM-DD
}

export async function uploadCert(payload: UploadCertPayload): Promise<WorkerProfile> {
  const form = new FormData();
  form.append("file", payload.file);
  form.append("category", payload.category);
  if (payload.name) form.append("name", payload.name);
  if (payload.expires_on) form.append("expires_on", payload.expires_on);
  const { data } = await apiClient.post<WorkerProfile>("/workers/me/certifications", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function removeCert(certId: string): Promise<WorkerProfile> {
  const { data } = await apiClient.delete<WorkerProfile>(
    `/workers/me/certifications/${certId}`,
  );
  return data;
}
